var _path, _path2, _path3, _path4, _path5, _path6, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMmusicLogoWhiteText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 35,
    viewBox: "0 0 64 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4409 11.9109C14.7708 11.9109 13.3281 12.5902 12.445 13.7236C11.6605 12.5084 10.342 11.9109 8.79591 11.9109C7.37405 11.9109 6.13738 12.4051 5.31315 13.3533V12.0749H2.2384V23.1623H5.45417V17.5987C5.45417 15.6201 6.46358 14.6927 7.88748 14.6927C9.22719 14.6927 9.99049 15.5171 9.99049 17.3106V23.1623H13.2042V17.5987C13.2042 15.6201 14.2157 14.6927 15.6587 14.6927C16.9563 14.6927 17.7617 15.5171 17.7617 17.3106V23.1623H20.9775V16.8144C20.9755 13.4355 19.0806 11.9109 16.4409 11.9109V11.9109Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2264 17.5568C31.2264 19.5984 30.1557 20.5446 28.6712 20.5446C27.1867 20.5446 26.4251 19.7202 26.4251 17.8658V12.075H23.2094V18.3408C23.2094 21.7618 25.1672 23.326 27.95 23.326C29.2572 23.3599 30.5141 22.8223 31.3927 21.8542V23.1727H34.4421V12.075H31.2264V17.5568V17.5568Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3801 15.372C39.3801 14.7957 39.9983 14.3416 41.4413 14.3416C42.5603 14.331 43.6621 14.6154 44.6359 15.166L45.7086 12.8804C44.6571 12.2497 42.9744 11.9109 41.4413 11.9109C38.2047 11.9109 36.3098 13.3954 36.3098 15.4959C36.3098 19.9261 43.0083 18.0716 43.0083 19.8864C43.0083 20.5044 42.4511 20.8955 40.9683 20.8955C39.6104 20.8897 38.279 20.5194 37.1131 19.823L36.0404 22.136C37.071 22.8153 38.968 23.3303 40.844 23.3303C44.1628 23.3303 46.079 21.8585 46.079 19.8063C46.0769 15.435 39.3804 17.2685 39.3804 15.3717L39.3801 15.372Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2855 6.94531C48.0889 6.94531 47.2855 7.72759 47.2855 8.73675C47.2855 9.74592 48.0889 10.5302 49.2855 10.5302C50.4821 10.5302 51.2834 9.74797 51.2834 8.67584C51.2834 7.68755 50.4801 6.94531 49.2855 6.94531Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8923 12.075H47.6765V23.1624H50.8923V12.075Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6615 20.6895C57.0335 20.6895 55.7548 19.5561 55.7548 17.6196C55.7548 15.6831 57.0335 14.5476 58.6615 14.5476C59.6709 14.5476 60.5543 15.0229 61.1557 16.0742L63.6499 14.7348C62.8445 12.9201 61.0106 11.9109 58.6823 11.9109C55.0733 11.9109 52.4969 14.2807 52.4969 17.6196C52.4969 20.9585 55.0733 23.3262 58.6823 23.3262C61.0106 23.3262 62.8445 22.2958 63.6499 20.5256L61.1557 19.1653C60.5564 20.2357 59.6709 20.6899 58.6615 20.6899V20.6895Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    x2: 0.5,
    y2: 35,
    stroke: "#111827",
    strokeOpacity: 0.01
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMmusicLogoWhiteText);
export default __webpack_public_path__ + "static/media/mmusic-logo-white-text.863ee2586362595fc6c0aef79a5ea8df.svg";
export { ForwardRef as ReactComponent };